import { render, staticRenderFns } from "./trxrekening.vue?vue&type=template&id=144ffbca"
import script from "./trxrekening.vue?vue&type=script&lang=js"
export * from "./trxrekening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports